import api from '../services/api';

// Customers API functions
export const getCustomers = async (params = {}) => {
  try {
    const response = await api.get('/customers', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching customers:', error);
    throw error;
  }
};

export const getIncognitoCustomers = async () => {
  try {
    const response = await api.get('/customers/incognito');
    return response.data;
  } catch (error) {
    console.error('Error fetching incognito customers:', error);
    throw error;
  }
};

export const getSentCustomers = async () => {
  try {
    const response = await api.get('/customers/sent');
    return response.data;
  } catch (error) {
    console.error('Error fetching sent customers:', error);
    throw error;
  }
};

export const getConfirmedCustomers = async () => {
  try {
    const response = await api.get('/customers/confirmed');
    return response.data;
  } catch (error) {
    console.error('Error fetching confirmed customers:', error);
    throw error;
  }
};

export const getRejectedCustomers = async (params = {}) => {
  try {
    const response = await api.get('/customers/rejected', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching rejected customers:', error);
    throw error;
  }
};

export const getSentLinksCount = async () => {
  try {
    const response = await api.get('/customers/sent_links');
    return response.data;
  } catch (error) {
    console.error('Error fetching sent links count:', error);
    throw error;
  }
};

export const getTestCustomers = async () => {
  try {
    const response = await api.get('/customers/test');
    return response.data;
  } catch (error) {
    console.error('Error fetching test customers:', error);
    throw error;
  }
};

export const sendCustomerLinks = async (sendData) => {
  try {
    const response = await api.post('/customers/send', sendData);
    return response.data;
  } catch (error) {
    console.error('Error sending customer links:', error);
    throw error;
  }
};

export const getCustomerDetail = async (account) => {
  try {
    const response = await api.get(`/customers/detail/${account}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching customer detail:', error);
    throw error;
  }
};

export const getCustomerPortalLink = async (account) => {
  try {
    const response = await api.get(`/customers/link/${account}`);
    return response.data;
  } catch (error) {
    console.error('Error generating customer portal link:', error);
    throw error;
  }
};

export const saveCustomerDetails = async (payload) => {
  try {
    const response = await api.post('/customers/save', payload);
    return response.data;
  } catch (error) {
    console.error('Error saving customer details:', error);
    throw error;
  }
};

export const confirmOTP = async (otpData) => {
  try {
    const response = await api.post('/customers/confirm', otpData);
    return response.data;
  } catch (error) {
    console.error('Error confirming OTP:', error);
    throw error;
  }
};

export const submitCustomer = async (customerData) => {
  try {
    const response = await api.post('/customers/submit', customerData);
    return response.data;
  } catch (error) {
    console.error('Error submitting customer:', error);
    throw error;
  }
};

export const saveCustomer = async (customerData) => {
  try {
    const response = await api.post('/customers', customerData);
    return response.data;
  } catch (error) {
    console.error('Error saving customer:', error);
    throw error;
  }
};

export const getCustomerForUpdate = async (id) => {
  try {
    const response = await api.get(`/customers/update/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching customer for update:', error);
    throw error;
  }
};

export const processCustomer = async (id) => {
  try {
    const response = await api.post(`/customers/processed/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error processing customer:', error);
    throw error;
  }
};

export const rejectCustomer = async (id) => {
  try {
    const response = await api.post(`/customers/reject/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error rejecting customer:', error);
    throw error;
  }
};
